export const CompanySearch = {
    lists: [],
    suppression_lists: [],
    company_naics_codes: '',
    company_location_zipcodes: [],
    company_min_size: '',
    company_max_size: '',
    company_location_zipcodes_distance: 0,
    technographics: 0,
    rankings: {
        fast100: false,
        fast500: false,
        federalcontractors: false,
        forbesglobal2000: false,
        fortune500: false,
        fortune1000: false,
        fundingRoundA: false,
        fundingRoundB: false,
        fundingRoundC: false,
        fundingRoundD: false,
        fundingRoundSeed: false,
        inc5000: false,
        linkedinTopStartups2021: false,
        managedServiceProviders: false,
        publicCompanies: false,
        saas1000: false,
        valueAddedResellers: false
    },
    company_technographic_categories: [],
    company_technographic_sub_categories: [],
    is_international: 0,
    location_country_codes: ['US'],
    company_location_hq: true,
    company_location_branch: true,
    contact_revenue_max_identifier: 'M',
    contact_revenue_min_identifier: 'M',
    accuracy_tier_company: 'MV',
    department_size: [],
    include_primary_industry_only: false
};
